module.exports = __webpack_public_path__ + "img/392ee18.jpg";